import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import { IRingCentral } from '~/utils/interface/ring-central';

const ringCentralApi = {
  getRingCentral() {
    return axiosClient.get<IApiBaseResponse<IRingCentral>>('/api/admin/ring-centrals');
  },

  updateRingCentral(data: IRingCentral) {
    return axiosClient.put<IApiBaseResponse<IRingCentral>>('/api/admin/ring-centrals', data);
  },
};

export default ringCentralApi;
